// @flow

export const orderTypes = Object.freeze({
  Common: 'common',
  Personal: 'personal',
  All: 'all',
});

export type OrderType = $Values<typeof orderTypes>
